export abstract class UserRoleConsts {
    static readonly DSS_SPECIALIST_ROLE: string = 'DSS Specialistas';
    static readonly ADMIN_ROLE: string = 'admin';
    static readonly EMPLOYEE_ROLE: string = 'Darbuotojas';
}